import * as React from 'react';
import { useClickAway } from 'react-use';
import NavigationDropdown from '../NavigationDropdown/NavigationDropdown';
import S from './Navigation.styles';
const Navigation = ({ items, activeId, setActiveId, setIsDesktopNavigationActive, }) => {
    const refContainer = React.useRef(null);
    useClickAway(refContainer, () => {
        setIsDesktopNavigationActive(false);
        return setActiveId('');
    });
    return (React.createElement(S.Navigation, { ref: refContainer },
        React.createElement(S.NavigationList, null, items.map((item) => (React.createElement(S.NavigationItem, { key: item.id },
            React.createElement(S.NavigationLink, { "data-active": item.isActive, href: item.url, target: item.target, onClick: (event) => {
                    setIsDesktopNavigationActive(true);
                    if (!item.children?.length) {
                        return setActiveId('');
                    }
                    event.preventDefault();
                    if (item.id === activeId) {
                        setIsDesktopNavigationActive(false);
                        setActiveId('');
                    }
                    else {
                        setActiveId(item.id);
                    }
                } }, item.text),
            !!item.children?.length && (React.createElement(NavigationDropdown, { items: item.children, title: item.text, image: item.image, url: item.url, visible: item.id === activeId }))))))));
};
export default Navigation;
